import React from 'react'

import { Button, useMediaQueryContext } from '@fourthwall/components'
import { useSamplesBudgetBalance } from '@modules/Dashboard/pages/Settings/pages/Samples/hooks/useSamplesBudgetBalance'
import { routing } from '@utils/routing'

import { SamplesCreditBalance } from '../../components/SamplesCreditBalance/SamplesCreditBalance'
import * as S from './SamplesRecommendationContent.styled'

export const SamplesRecommendationContent = () => {
  const media = useMediaQueryContext()
  const { samplesBudgetBalance } = useSamplesBudgetBalance()

  return (
    <S.Container>
      <S.ButtonWrapper>
        <Button
          analytics="samplesRecommendationClick"
          label="Order products for yourself"
          to={routing.settings.samples.self}
          fullWidth={!media.tablet}
          size="small"
        />
      </S.ButtonWrapper>
      {samplesBudgetBalance && !!samplesBudgetBalance.value && (
        <SamplesCreditBalance
          label="Your sample credit"
          balance={samplesBudgetBalance}
          tooltip="Sample credit can be used to order samples of your products to use for quality reviews, photography, and promotion videos!"
        />
      )}
    </S.Container>
  )
}
